/**
 * Lazy-loads the Swiper carousel module into a shared async chunk
 * so every page entry reuses one download instead of bundling Swiper repeatedly.
 */
export default function loadComponentCarousel(
    context: Document | HTMLElement = document
): Promise<void> {
    return import(
        /* webpackChunkName: "component-carousel" */
        './component-carousel'
    ).then((module) => {
        module.default(context);
    });
}
